import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LoaderForImage from "../../LoaderForImage";
import upploadImage from "../../../assets/images/upload-video.png";
import { imageUpload } from "../../../features/slices/liveStream";
import { toastService } from "../../../utils/toastify";
import { useDispatch } from "react-redux";
import { editPrize } from "../../../features/slices/challanges";
const initailState = {
  name: "",
  prizeNo: "",
  description: "",
  image: "",
  id: "",
};
const ViewPrize = () => {
  const [iState, setUpdateState] = useState(initailState);
  const [imageLoader, setImageLoader] = useState(false);
  const { name, prizeNo, description, image } = iState;
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    setUpdateState((prev) => ({
      ...prev,
      name: state?.name,
      prizeNo: state?.prizeNo,
      description: state?.description,
      image: state?.image,
      id: state?._id,
    }));
  }, []);
  const handleChange = (e) => {
    const { name, value } = e?.target;
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleImage = (e) => {
    const file = e.target.files[0];

    if (file) {
      const formData = new FormData();
      formData.append("fileName", file);
      dispatch(imageUpload(formData)).then((res) => {
        if (res?.payload?.code === 200) {
          toastService.success("Image uploaded successfully");
          setUpdateState({
            ...iState,
            [e.target.name]: res?.payload?.url,
          });
          setImageLoader(false);
        } else {
          toastService.error("Failed to upload");
          setImageLoader(false);
        }
      });
    }
  };
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">Prize Details</h4>
          </div>
          <div className="CommonForm">
            <figure
              style={{
                width: "50%",
              }}
            >
              <img
                src={image}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "10px",
                }}
              />
            </figure>
            <div className="form-group">
              <label>Prize Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Prize No."
                value={name}
                disabled
              />
            </div>
            <div className="form-group">
              <label>Prize No.</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Prize No."
                value={prizeNo}
                disabled
              />
            </div>
            <div className="form-group">
              <label>Prize Description</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Prize Description"
                value={description}
                disabled
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewPrize;
